const SET_SERVER_ERROR_500 = 'SET_SERVER_ERROR_500'

export default {
  namespaced: true,

  state () {
    return {
      serverError500: false
    }
  },

  getters: {
    serverError500: (state) => state.serverError500
  },

  mutations: {
    [SET_SERVER_ERROR_500] (state, data) {
      state.serverError500 = data
    }
  },

  actions: {
    setServerErrorStatus ({ commit }, status) {
      commit(SET_SERVER_ERROR_500, status)
    }
  }
}
